/**
 * Created by vblanco on 27/04/2017.
 */
(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('ResponsableAdminController', ResponsableAdminController);

    /* @ngInject */
    function ResponsableAdminController($timeout, $stateParams, NG_TABLE_DEFAULT_PARAMS, NgTableParams, NgTableHelper,
                                        ModalService, Responsable, AlertService, letras, $state) {
        var vm = this;

        // Letras
        vm.letras = letras;
        vm.values = {};


        vm.esCanonico = false;

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });
        vm.originalData = [];


        vm.item = Responsable;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.elementosPorPagina = NG_TABLE_DEFAULT_PARAMS.size;
        vm.filter = {
            key: undefined,
            letra: $stateParams.letra,
            revisado: undefined
        };


        vm.tableParams = new NgTableParams({
            count: vm.elementosPorPagina,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {nombre: 'asc'}
        }, NgTableHelper.settings(vm));


        // Eliminar
        vm.showRemoveConfirmation = function (responsable) {

            //si tiene alguna obra, no se puede eliminar
            if ((responsable.numAutor > 0) || (responsable.numImpresor > 0) || (responsable.numEditor > 0)
                || (responsable.numTraductor > 0) || (responsable.numOtros > 0)) {
                AlertService.warning("admin.responsable.error.notdeleteablePorObras");
                return;
            }
            //si tiene alguna variante asociada, no se puede eliminar
            if ((responsable.variantes !== null) && (responsable.variantes.length > 0)) {
                AlertService.warning("admin.responsable.error.notdeleteablePorVariantes");
                return;
            }
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    keyboard: false,
                    resolve: {
                        item: function () {
                            return Responsable.get({id: responsable.id}).$promise;
                        },
                        params: function () {

                            return {
                                title: 'admin.responsable.delete.name',
                                body: 'admin.responsable.delete.confirm',
                                property: 'nombreCompleto'
                            };
                        }
                    }
                }
            ).result.then(function () {
                    var originalTable = vm.tableParams;
                    for (i = 0; i < originalTable.data.length; i++) {
                        var originalData = originalTable.data[i];

                        if (originalData.id === responsable.id) {
                            originalTable.data.splice(i, 1);
                        } else {
                            if (originalData.variantes.length > 0) {
                                for (var j = 0; j < originalData.variantes.length; j++) {
                                    if (originalData.variantes[j].id === responsable.id) {
                                        originalData.variantes.splice(j, 1);
                                    }
                                }
                            }
                        }
                    }
                }
            );
        };


        //Añadir un elemento a la tabla
        vm.addElementTable = function () {

            var originalTable = vm.tableParams;
            //no se permite añadir varios elementos simulatenamente
            if ((originalTable.data.length === 0) || (originalTable.data[0].id)) {

                var copia = {isEditing: true};
                originalTable.data.unshift(copia);
            }
        };


        //Edicion en linea: Guardar una copia de la fila que se va a editar
        vm.saveState = function (row, rowForm) {
            vm.originalData = angular.copy(row);
            var originalTable = vm.tableParams;

        };

        //Cancelar la edición de una fila
        vm.cancel = function (row, rowForm) {
            var originalTable = vm.tableParams;

            //Si se estaba añadiendo una nueva fila -> se elimina
            if (!row.id) {
                originalTable.data.shift();

            } else { //sino, se queda como estaba
                var originalRow = angular.copy(vm.originalData);
                angular.extend(row, originalRow);
                row.isEditing = false
            }
        };

        vm.setRevisado = function (data) {
            Responsable.setRevisado({id: data.id, revisado: data.revisado}).$promise.then(function () {
                vm.tableParams.reload();
            });
        };

        /**
         * responsableCanonico: es el objeto Responsable, que es un atributo de la clase Responsable
         * A mayores, tambien tiene un id_canonico y un nombre_canonico, propios del ResponsableDTO
         * es_canonico es necesario para implementar el checkbox
         * @param row
         * @param rowForm
         */
        vm.save = function (row, rowForm) {
            var originalRow = angular.copy(vm.originalData);

            var antesNumeroVariantes = null;

            if (originalRow.variantes != null) {
                antesNumeroVariantes = originalRow.variantes.length;
            }

            var antesIdCanonico = null;

            if (originalRow.responsablecanonico != null) {
                antesIdCanonico = originalRow.responsablecanonico.id;
            }

            var ahoraEsCanonico = (row.es_canonico);
            var ahoraTieneNombrecanonico = (row.responsablecanonico != null);
            var ahoraIdCanonico = null;
            if (row.responsablecanonico != null) {
                ahoraIdCanonico = row.responsablecanonico.id;
            }

            //Si tiene el nombre y el apellido en blanco -> no se puede guardar
            if (row.nombre == null && row.apellidos == null || row.nombre == '' && row.apellidos == '') {
                AlertService.warning("admin.responsable.error.responsableSinDatos");
                return;
            }

            //Si no es canonico y no le añades un nombre de canonico
            //A pesar del required, puede ocurrir
            if (!ahoraEsCanonico && !ahoraTieneNombrecanonico) {
                AlertService.warning("admin.responsable.error.responsableIncompleto");
                return;
            }

            //Si es canonico, ponemos la variable asociada responsableCanonico a null(problemas de compatibilidad con backend)
            if (ahoraEsCanonico) {
                row.responsablecanonico = null;
            }

            //Modificar responsable: Si antes era canonico, tiene variantes, y ahora se quiere convertir a variante -> no se puede ACTUALIZAR
            // (ej: si antes era canonico, y ahora lo sigue siendo, sí se podría actualizar
            if (antesIdCanonico == null && !ahoraEsCanonico && antesNumeroVariantes > 0) {
                AlertService.warning("admin.responsable.error.notdeleteablePorVariantes");
                return;
            }

            new Responsable(row).$save().then(function (data) {
                row.isEditing = false;
                rowForm.$setPristine();
                angular.extend(row, data);

                vm.tableParams.reload();
            });
        };

        //Ir a las relaciones de un autor
        vm.verRelaciones = function (id, nombre, apellidos) {
            var nombreAEnviar = "";
            if(nombre != null){
                nombreAEnviar= nombreAEnviar.concat(nombre);
            }if(apellidos != null){
                nombreAEnviar= nombreAEnviar.concat(" " + apellidos);
            }
            $state.go("admin/relacion/list", {idAutor:id, nombreAutor: nombreAEnviar});
        };

        //Ir a las ediciones de un responsable
        vm.verEdiciones = function (id, nombre, apellidos, rol) {
            var nombreAEnviar = "";
            if(nombre != null){
                nombreAEnviar= nombreAEnviar.concat(nombre);
            }if(apellidos != null){
                nombreAEnviar= nombreAEnviar.concat(" " + apellidos);
            }
            $state.go("admin/buscador/list", {idResponsable:id, nombreResponsable: nombreAEnviar, rolResponsable: rol});
        };

        vm.responsableService = Responsable;
    }
})(angular);
